import Table from '../Page/Table';

export default Table;
